export default "__VITE_ASSET__Cpsa_YW___"